"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbTrusted = void 0;
const types_1 = require("../../../features/authoriser/types");
const repository_1 = require("../../../features/authoriser/infra/repositories/checkTrustedVerificationStatus/repository");
const repository_2 = require("../../../features/authoriser/infra/repositories/repository");
const events_1 = require("../../../features/events");
const baseTrusted_1 = require("./baseTrusted");
class MbTrusted extends baseTrusted_1.BaseTrusted {
    constructor(api, data, session, asyncConnectionUrlConfig, mbTrustedUrlConfig, eventBus) {
        super(api, data, session, asyncConnectionUrlConfig);
        this.doRetry = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield (0, repository_2.regeneratePUSH)(this.api, this.progressId, this.mbTrustedUrlConfig.retry);
                this.data = Object.assign(Object.assign({}, this.data), { biometricId: data.biometricId });
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION, success: true }, this.eventBus);
            }
            catch (_) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION, success: false }, this.eventBus);
            }
        });
        this.mbTrustedUrlConfig = mbTrustedUrlConfig;
        this.eventBus = eventBus;
    }
    doVerify() {
        return __awaiter(this, void 0, void 0, function* () {
            this.closeAsyncConnection();
            const checkVerificationData = { biometricId: this.data.biometricId };
            const isVerified = yield repository_1.trustedVerificationStatusRepository.isVerified(this.api, this.progressId, checkVerificationData, this.mbTrustedUrlConfig.verify);
            if (!isVerified) {
                throw new Error('Validation from the trusted device is required');
            }
            return {
                type: types_1.ChallengeType.NONE,
                progressId: this.progressId,
            };
        });
    }
}
exports.MbTrusted = MbTrusted;
//# sourceMappingURL=trusted.js.map